export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 2a1 1 0 011 1v2.5h4.5a1 1 0 011 1v13a1 1 0 01-1 1h-19a1 1 0 01-1-1v-13a1 1 0 011-1H7V3a1 1 0 011-1h8zM3.5 7.5v11h17v-11H17V10h1.5v2h-13v-2H7V7.5H3.5zM9 10h6V4H9v6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};